
    import { backendExceptionHandler } from "@/mixins";

    const COMMON_TYPE_OF_INTRO = {
        ImportierenManuell: 0,
        ImportierenAutomatisch: 1,
        ManuellErstellen: 2,
        DefineAsset: 3
    }

    export default {
        name: "IntroductionCreatePortfolioModal",
        mixins: [ backendExceptionHandler ],
        components: {

        },
        data() {
            return {
                isVisible: false,
                loading: false,
                typeOfIntro: 0,
                commonTypeOfIntro: COMMON_TYPE_OF_INTRO
            }
        },

        computed: {

        },

        methods: {
            openWindow(index) {
                this.typeOfIntro = index;
                this.$nextTick(() => this.isVisible = true)
            },
            closeWindow() {
                this.isVisible = false;
                this.typeOfIntro = 0;
                this.$emit('portfolio-intro-close');
            }

        },

        created() {

        },

        beforeMount() {
            this.$root.$on('open-intro-create-portfolio-dialog', this.openWindow)
        },

        beforeDestroy() {
            this.$root.$off('open-intro-create-portfolio-dialog', this.openWindow)
        },

        watch: {
            isVisible(newValue, oldValue) {
                if(!newValue){
                    const videoIntro = this.$refs.videoIntroElement;
                    if(videoIntro) {
                        const srcVideo = videoIntro.src;
                        videoIntro.src = `${srcVideo}`
                    }
                }
            }
        }
    }

